type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const SCHEDULES_PAGES: ImpactModulePages = {
  SCHEDULE_BOOKING: {
    name: 'Agendas',
    description: 'Gestão das permissões da página de agendas',
  },
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupos',
    description: 'Gestão das permissões dos grupo',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões dos agentes',
    description: 'Gestão das permissões dos agentes públicos',
  },
  SCHEDULE_SKELETON: {
    name: 'Escalas',
    description: 'Gestão das permissões da página de escalas',
  },
  SCHEDULE_PLANNING: {
    name: 'Planejamentos',
    description: 'Gestão das permissões da página de planejamentos',
  },
}
